import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BuyersEditCardDialogComponent } from 'src/app/buyers/buyers-edit-card-dialog/buyers-edit-card-dialog.component';
import { DialogService } from 'src/app/core/dialog.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { StripePaymentSource } from 'src/app/core/stripe-payment-sources.service';

@Component({
  selector: 'app-buyer-details-general-card',
  templateUrl: './buyer-details-general-card.component.html',
  styleUrls: ['./buyer-details-general-card.component.scss'],
})
export class BuyerDetailsGeneralCardComponent {
  @Input() buyer_id?: string;
  @Input() payment_sources?: StripePaymentSource[];
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(private readonly dialog_service: DialogService, private readonly error_service: ErrorService) {}

  getCardLogo(funding: string): string {
    const prefix = '../../assets/img/payment_methods/';
    switch (funding) {
      case 'mastercard':
        return prefix + 'mastercard-logo.png';
      case 'visa':
        return prefix + 'visa-logo.png';
      case 'amex':
        return prefix + 'american-express-logo.png';
      default:
        return '';
    }
  }

  onDeleteCardClick(): void {
    this.dialog_service
      .openDialog(BuyersEditCardDialogComponent, {
        buyer: {
          buyer_id: this.buyer_id,
        },
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result?.success) {
          this.refresh.emit();
        }

        if (dialog_result?.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }
}
